/* This will automatically determine the form to show, with all the required variables */

import { FormContextProvider } from '../contexts/FormContext';
import FeedbackForm from './FeedbackForm';

export default function FeedbackFormContainer(props) {
         
    return ( 
        <FormContextProvider>
            <FeedbackForm {...props} />
        </FormContextProvider>
    )
    
}